import BreadcrumbAndTitle from "@components/BreadcrumbAndTitle";
import { BreadcrumbChild } from "@components/BreadcrumbCustom";
import ButtonLinkGeneric from "@components/ButtonLinkGeneric/ButtonLinkGeneric";
import ROUTES from "@config/routes";
import { Box, Grid } from "@mui/material";
import React, { useRef, useState } from "react";
import ContactChannelsButton from "../components/ContactChannelsButton";
import ContactChannelsModal from "../components/ContactChannelsModal";

const OpenNewReclamation: React.FC = () => {
  const [isContactModalOpen, setIsContactModalOpen] = useState(false);
  const contactButtonRef = useRef<HTMLButtonElement>(null);

  const handleOpenModal = () => {
    setIsContactModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsContactModalOpen(false);
    contactButtonRef.current?.focus();
  };

  const breadcrumbDataOrders: BreadcrumbChild[] = [
    {
      link: ROUTES.USER_ROUTES.HOME,
      label: "Início",
    },
    {
      label: "Fale conosco",
    },
  ];

  return (
    <Grid
      container
      className="criar-nova-reclamacao"
      alignItems={"center"}
      justifyContent={"space-between"}
      sx={{ border: "0px solid red" }}
    >
      <Grid item xs={6}>
        <BreadcrumbAndTitle
          breadcrumbData={breadcrumbDataOrders}
          title="Fale conosco"
        />
      </Grid>

      <Grid item>
        <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
          <ContactChannelsButton
            onClick={handleOpenModal}
            buttonRef={contactButtonRef}
          />
          <ButtonLinkGeneric
            text={"Abrir novo registro"}
            link={ROUTES.USER_ROUTES.RECLAMATION}
          />
        </Box>
      </Grid>

      <ContactChannelsModal
        open={isContactModalOpen}
        onClose={handleCloseModal}
      />
    </Grid>
  );
};

export default OpenNewReclamation;
